import { defineStore } from 'pinia'
import { useSet } from '../useSet'
import { usePredicates } from '@/ContextTab/stores/newsSet/usePredicates'


export const useInProgressNewsStore = defineStore('inProgressNews', () => {

  const { taskPanelPredicates } = usePredicates()

  return useSet({
    setType: 'inProgress',
    predicates: taskPanelPredicates.inProgress,
  })
})
